import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { Divider } from '@mui/material';
import { useLocation } from 'react-router-dom';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#confirm-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const ConfirmDialog = ({ prompt, onConfirm, onCancel, onClose }) => {

    const location = useLocation();

    useEffect(() => {
        onClose();
    }, [location.pathname]);

    const onNo = () => {
        onClose()
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <Dialog
            open={prompt !== null}
            onClose={onClose}
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <DialogTitle id="confirm-dialog-title">
                {prompt?.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-dialog-description">
                    <Typography sx={{ whiteSpace: 'pre-line' }}>
                        {prompt?.message}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button fullWidth onClick={onConfirm}>Yes</Button>
                <Divider orientation="vertical" flexItem />
                <Button fullWidth onClick={onNo}>No</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
